import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { BASENAME, PILLAR_SLUGS } from './langPath';

// Import Layout Components
import NavBar from './components/Navbar/NavBar';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import ScrollToTop from './components/ScrollToTop';

// Import All Pages
import Home from './pages/Home';
import Solutions from './pages/Solutions';
import SolutionPage from './pages/SolutionPage';
import Technology from './pages/Technology';
import Industries from './pages/Industries';
import CaseStudiesPage from './pages/CaseStudiesPage';
import AboutPage from './pages/AboutPage';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import RequestDemo from './pages/RequestDemo';
import Imprint from './pages/Imprint';
import GTC from './pages/GTC';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PillarIndustrialAI from './pages/PillarIndustrialAI';


function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <Router basename={BASENAME}>
      <ScrollToTop>
        {/* The NavBar is rendered once here, on every page */}
        <NavBar />

        <main className="pt-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/:slug" element={<SolutionPage />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/request-demo" element={<RequestDemo />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/gtc" element={<GTC />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* Hungarian-only topic pillar; prerendered under /hu only */}
            {/* Topic pillar: one localized slug per language tree. Only the slug
                matching a tree is prerendered there; the others 404 server-side. */}
            {Object.values(PILLAR_SLUGS).map((slug) => (
                <Route key={slug} path={slug} element={<PillarIndustrialAI />} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        {/* The Footer is rendered once here, on every page */}
        <Footer />
        <ChatWidget />
      </ScrollToTop>
    </Router>
  );
}

export default App;
